/** Имя UXFB-события захода на карточку ЖК. Должно побайтово совпадать с кампаниями в админке UXFB. */
export const UXFB_EVENT_OPEN_ZHK_CARD = 'open_zhk_card';

/** Сервис обслуживает только десктопную карточку ЖК, поэтому платформа фиксированная. */
export const UXFB_PLATFORM = 'desktop';

/** Карточка ЖК — всегда новостройки на продажу. */
export const UXFB_DEAL_TYPE = 'sale';

/**
 * Kill-switch клиентских UXFB-событий. По умолчанию события включены; выключаются значением `false`
 * в конфиге (`uxfeedback.clientEvents.enabled`).
 */
export const UXFB_CLIENT_EVENTS_CONFIG_KEY = 'uxfeedback.clientEvents.enabled';
